import React from "react";

function CheckConnectivityUsernameField({ value, onChange, disabled }) {

    return (
        <div className="oct-shared-popup__field">
            <label className="oct-shared-popup__label" htmlFor="username">
                Username <span className="oct-shared-popup__required-mark">*</span>
            </label>
            <input
                className="oct-shared-popup__input"
                id="username"
                value={value}
                autoComplete="off"
                disabled={disabled}
                placeholder="Enter username"
                onChange={event => onChange(event.target.value)}
            />
        </div>
    )

}

export default CheckConnectivityUsernameField;
